<template>
    <v-app pb-3>
        <v-container class="osago-pre-calc-steps mortgage-container" style="max-width: 1240px;">
            <v-content>
                <v-form ref="form" v-model="valid">
                    <mortgage-precalc-info v-model="precalcInfo" :showContractDate="false"></mortgage-precalc-info>
                    <mortgage-calc-info v-model="calcInfo"></mortgage-calc-info>
                    <v-container style="max-width: 1240px" pt-0>
                        <v-layout v-if="orderStatus === 'new'" pt-4 row wrap>
                            <v-flex xs12 sm6>
                                <v-btn @click="validate"
                                       :loading="wait"
                                       class="submit-button block to-counting">
                                    Рассчитать окончательную стоимость
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-content>

            <transition name="fade">
                <mortgage-preview
                    v-if="showPreview"
                    :preparedFormData="preparedFormData"
                    :return="this.returnToEdit"
                    :submit="this.submit"
                    :b2b="b2b"
                />
            </transition>

            <v-content v-if="companiesList.length">
                <v-layout row wrap>
                    <v-flex xs12 pt-5>
                        <mortgage-calc-result :data="companiesList"/>
                    </v-flex>
                </v-layout>
            </v-content>
        </v-container>
    </v-app>
</template>

<script>
import ymMixin from "../../mixins/ym";
import helperMixin from "../../mixins/helper";
import _ from "lodash";
import MortgageCalcResult from "./MortgageCalcResult";

export default {
    name: "MortgageLongForm",
    mixins: [ymMixin, helperMixin],
    props: ['params'],
    components: {
        'mortgage-calc-result': MortgageCalcResult
    },
    data: () => ({
        valid: false,
        uuid: null,
        wait: false,
        orderStatus: 'new',
        b2b: true,
        preparedFormData: {},
        lastSavedFormData: {},
        autoSaveInterval: null,
        showPreview: false,
        companiesList: [],

        precalcInfo: {
            bank: null,
            creditRemainder: null,
            gender: null,
            birthday: null,
            additionalProperties: {
                hasWoodenFloors: false,
                houseGasificated: false
            }
        },
        calcInfo: {
            noContractNumber: false,
            contract: {
                number: null,
                dateStart: null,
                mortgageRate: null
            },
            policyStartDate: null,
            user: {
                phone: '7',
                email: null,
            },
            fio: {
                name: null,
                surname: null,
                patronymic: null
            },
            birthday: null,
            passport: {
                date: null,
                seriesNumber: null,
                subdivisionCode: null,
                issuedBy: null
            },
            height: null,
            weight: null,
            registrationAddress: {
                search: null,
                city: null,
                street: null,
                house: null,
                house_kladr: null,
                house_fias: null,
                flat: null,
                flat_cadnum: null,
                city_fias_id: null,
                postalCode: null,
                region: null,
            },
            mortgageAddress: {
                search: null,
                city: null,
                street: null,
                house: null,
                house_kladr: null,
                house_fias: null,
                flat: null,
                postalCode: null,
                region: null,
                flat_cadnum: null,
                city_fias_id: null
            },
            buildYear: null,
            floorsNumber: null,
            apartmentArea: null,
        },
    }),
    created() {
        const params = JSON.parse(window.atob(this.params));

        this.uuid = params.uuid;
        if (params.orderData) {
            this.loadOrderData(params.orderData);
        }
        if (params.companies) {
            this.companiesList = params.companies;
        }

        this.lastSavedFormData = this.preparedFormData;
        this.autoSaveOn(5000);
    },
    methods: {
        autoSaveOn(timeout) {
            this.autoSaveInterval = setInterval(() => {
                this.prepareFormData();

                if (this.lastSavedFormData == null) {
                    this.lastSavedFormData = _.cloneDeep(this.preparedFormData);
                    return;
                }
                if (!_.isEqual(this.lastSavedFormData, this.preparedFormData)) {
                    this.save();
                    this.lastSavedFormData = _.cloneDeep(this.preparedFormData);
                }
            }, timeout);
        },
        autoSaveOff() {
            clearInterval(this.autoSaveInterval);
        },
        loadOrderData(data) {
            this.precalcInfo.bank = data.bank;
            this.precalcInfo.creditRemainder = data.remainingCredit.replace(/\s/g, '');
            this.precalcInfo.additionalProperties = {
                houseGasificated: data.additional.houseGasificated,
                hasWoodenFloors: data.additional.hasWoodenFloors
            }
            this.precalcInfo.gender = data.insurer.gender;
            this.precalcInfo.birthday = data.insurer.birthdate;

            this.calcInfo.noContractNumber = false;
            this.calcInfo.contract = {
                number: data.contract.number,
                dateStart: data.contract.startDate,
                mortgageRate: data.contract.mortgageRate,
                creditPercentBetRefus: data.contract.creditPercentBetRefus
            };
            this.calcInfo.policyStartDate = data.mortgage.startDate;
            this.calcInfo.buildYear = data.mortgage.buildYear;
            this.calcInfo.floorsNumber = data.mortgage.floorsNumber;
            this.calcInfo.apartmentArea = data.mortgage.apartmentArea;
            this.calcInfo.user = {
                email: data.user.email,
                phone: data.user.phone
            };
            this.calcInfo.fio = {
                name: data.insurer.fio.name,
                surname: data.insurer.fio.surname,
                patronymic: data.insurer.fio.patronymic
            };
            this.calcInfo.birthday = data.insurer.birthdate;
            this.calcInfo.height = data.insurer.height;
            this.calcInfo.weight = data.insurer.weight;
            this.calcInfo.passport = {
                date: data.insurer.passport.issueDate,
                seriesNumber: data.insurer.passport.seriesNumber,
                subdivisionCode: data.insurer.passport.subdivisionCode,
                issuedBy: data.insurer.passport.issuedBy
            };
            this.calcInfo.registrationAddress = {
                search: data.insurer.registrationAddress.string,
                house: data.insurer.registrationAddress.house,
                house_fias: data.insurer.registrationAddress.fias,
                house_kladr: data.insurer.registrationAddress.kladr,
                flat: data.insurer.registrationAddress.flat,
                flat_cadnum: data.insurer.registrationAddress.flat_cadnum,
                city_fias_id: data.insurer.registrationAddress.city_fias_id,
                postalCode: data.insurer.registrationAddress.postalCode,
                region: data.insurer.registrationAddress.region,
            };
            this.calcInfo.mortgageAddress = {
                search: data.mortgage.mortgageAddress.string,
                house: data.mortgage.mortgageAddress.house,
                house_fias: data.mortgage.mortgageAddress.fias,
                house_kladr: data.mortgage.mortgageAddress.kladr,
                flat: data.insurer.mortgageAddress.flat,
                postalCode: data.insurer.mortgageAddress.postalCode,
                region: data.insurer.mortgageAddress.region,
                flat_cadnum: data.insurer.mortgageAddress.flat_cadnum,
                city_fias_id: data.insurer.mortgageAddress.city_fias_id
            }
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.prepareFormData();
                this.showPreview = true;
                this.$nextTick(function () {
                    $('.preview-window').css('height', $(window).height());
                });
            } else {
                this.$nextTick(function () {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
            }
        },
        submit() {
            this.wait = true
            axios.post('/mortgage/calc/' + (this.uuid ? this.uuid + '/update' : 'new'), this.preparedFormData)
                .then(response => {
                    if (response.data.uuid) {
                        this.uuid = response.data.uuid;
                        window.history.pushState(null, null, '/mortgage/calc/' + this.uuid);
                    }
                    this.autoSaveOff();

                    this.showPreview = false;

                    this.precalc();
                }).catch(error => {this.catchSubmitError(error);})
                .finally(() => {this.wait = false});
        },
        save() {
            this.prepareFormData()
            axios.post('/mortgage/calc/' + (this.uuid ? this.uuid + '/update' : 'new'), this.preparedFormData)
                .then(response => {
                    if (response.data.uuid) {
                        this.uuid = response.data.uuid;
                        window.history.pushState(null, null, '/mortgage/calc/' + this.uuid);
                    }
                }).catch(error => {this.catchSubmitError(error);})
        },
        precalc() {
            axios.get('/mortgage/calc/' + this.uuid + '/precalc')
                .then(response => {
                    if (response.data) {
                        this.companiesList = response.data;
                    }
                }).catch(error => {this.catchError(error);})
        },
        prepareFormData() {
            this.preparedFormData = {
                bank: this.precalcInfo.bank,
                remainingCredit: this.precalcInfo.creditRemainder.replace(/\s/g, ''),
                user: {
                    email: this.calcInfo.user.email,
                    phone: this.calcInfo.user.phone
                },
                insurer: {
                    gender: this.precalcInfo.gender,
                    birthdate: this.calcInfo.birthday ? this.calcInfo.birthday : this.precalcInfo.birthday,
                    fio: {
                        surname: this.calcInfo.fio.surname,
                        name: this.calcInfo.fio.name,
                        patronymic: this.calcInfo.fio.patronymic
                    },
                    passport: {
                        seriesNumber: this.calcInfo.passport.seriesNumber,
                        issueDate: this.calcInfo.passport.date,
                        subdivisionCode: this.calcInfo.passport.subdivisionCode,
                        issuedBy: this.calcInfo.passport.issuedBy
                    },
                    height: this.calcInfo.height,
                    weight: this.calcInfo.weight,
                    registrationAddress: {
                        kladr: this.calcInfo.registrationAddress.house_kladr,
                        fias: this.calcInfo.registrationAddress.house_fias,
                        city: this.calcInfo.registrationAddress.city,
                        street: this.calcInfo.registrationAddress.street,
                        house: this.calcInfo.registrationAddress.house,
                        string: this.calcInfo.registrationAddress.search,
                        flat: this.calcInfo.registrationAddress.flat,
                        postalCode: this.calcInfo.registrationAddress.postalCode,
                        region: this.calcInfo.registrationAddress.region,
                        flat_cadnum: this.calcInfo.registrationAddress.flat_cadnum,
                        city_fias_id: this.calcInfo.registrationAddress.city_fias_id
                    }
                },
                contract: {
                    noNumber: false,
                    number: this.calcInfo.contract.number,
                    startDate: this.calcInfo.contract.dateStart,
                    mortgageRate: this.calcInfo.contract.mortgageRate
                },
                additional: {
                    hasWoodenFloors: this.precalcInfo.additionalProperties.hasWoodenFloors,
                    houseGasificated: this.precalcInfo.additionalProperties.houseGasificated
                },
                mortgage: {
                    mortgageAddress: {
                        kladr: this.calcInfo.mortgageAddress.house_kladr,
                        fias: this.calcInfo.mortgageAddress.house_fias,
                        city: this.calcInfo.mortgageAddress.city,
                        street: this.calcInfo.mortgageAddress.street,
                        house: this.calcInfo.mortgageAddress.house,
                        string: this.calcInfo.mortgageAddress.search,
                        flat: this.calcInfo.mortgageAddress.flat,
                        postalCode: this.calcInfo.mortgageAddress.postalCode,
                        region: this.calcInfo.mortgageAddress.region,
                        flat_cadnum: this.calcInfo.mortgageAddress.flat_cadnum,
                        city_fias_id: this.calcInfo.mortgageAddress.city_fias_id
                    },
                    buildYear: this.calcInfo.buildYear,
                    floorsNumber: this.calcInfo.floorsNumber,
                    apartmentArea: this.calcInfo.apartmentArea,
                    startDate: this.calcInfo.policyStartDate
                }
            };
        },
        goToFirstError() {
            this.$vuetify.goTo('.error--text', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },
        returnToEdit() {
            this.showPreview = false;
        },
        catchError(error) {
            console.log(error);
            this.showPreview = false;
            if (error.response.data.message) {
                PNotify.alert(error.response.data.message);
            }
            throw error;
        },
        catchSubmitError(error) {
            console.log(error);
            this.showPreview = false;
            if (error.response.data.message) {
                let errorTexts = '';

                if (error.response.data.errors) {
                    Object.keys(error.response.data.errors).forEach(function (item) {
                        error.response.data.errors[item].forEach(v => errorTexts += ' ' + v)
                    });
                }
                PNotify.alert(error.response.data.message + errorTexts);
            }
            throw error;
        },
    }
}
</script>

<style scoped>
.header-part h2 {
    font-size: 65px;
    line-height: 1;
    padding-bottom: 15px;
}

.header-part-title {
    padding-bottom: 40px;
}

@media screen and (max-width: 960px){
    .header-part h2 {
        font-size: 30px;
        padding-bottom: 20px;
    }
    .header-part-title {
        padding-bottom: 12px;
    }
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 100px;
    background-color: #00ba57 !important;;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: normal;
    padding: 0 50px;
    line-height: 1.1;
}

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgageLongForm.vue